export default __webpack_public_path__ + "static/media/chantilly.782f6cc1.jpg";